import http from "@axios";
import { getUserToken, getUserData } from "@/helpers/Utils";

const endpoint = `/event`;

const body = {
  req: {
    id: 123342523,
    time: "2021-08-09T10:11:20+07:00",
    src: "member-web",
    op: "listPassEvent",
  },
  data: {},
};

const listPassEvent = (data, v) => {
  //console.log("payload", data, v);
  let ocr = "";
  const user = getUserData();
  body.req.op = "listPassEvent"; // addPassEvent != listPassEvent
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  http.post(endpoint, body).then((res) => console.log(res));
  //return http.post(endpoint, body);

  return {
    data: {
      data: {
        rows: {
          event: [
            {
              id: 123,
              lane: data.lane,
              direction: v.direction,
              ocr: {
                lic_plate: ocr,
              },
              time: new Date()
                .toLocaleString("en-GB", { hour12: false })
                .replace(",", ""),
              image: {
                driver: v.cameras[0],
                front: v.cameras[1],
                back: v.cameras[2],
                left: v.cameras[3],
                right: v.cameras[4],
              },
              livecam: {
                driver: v.cameras[0],
                front: v.cameras[1],
                back: v.cameras[2],
                left: v.cameras[3],
                right: v.cameras[4],
              },
            },
          ],
        },
      },
    },
  };
};

const approvePass = (data) => {
  const user = getUserData();
  body.req.op = "approvePass"; // approveEvent != approvePass
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
};
export { listPassEvent, approvePass };
